import script from "./FinishingSetup.vue?vue&type=script&setup=true&lang=ts"
export * from "./FinishingSetup.vue?vue&type=script&setup=true&lang=ts"

import "./FinishingSetup.vue?vue&type=style&index=0&id=8944baa6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8944baa6"]])

export default __exports__